/* Built In Imports */
import { useState } from 'react';

/* External Imports */
import { Box, Image, Show, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import SimpleButton from '@components/Buttons/SimpleButton';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { nanoid } from 'nanoid';
import { useMediaQuery } from 'react-responsive';

/* Services */
/* Styles */

/**
 * @param {Object} card
 * @param {String} region
 * @param {String} lang
 * @param {String} flexBasis
 * @returns
 */
const ApplyStep = ({ card, index, btn, region, lang, bgcolor }) => {
  let readLessTxtCount = '';
  if (index == 0) {
    readLessTxtCount = 88;
  }
  else if (index == 1) {
    readLessTxtCount = 74;
  }
  else if (index == 2) {
    readLessTxtCount = 79;
  }
  else if (index == 3) {
    readLessTxtCount = 132;
  }
  else if (index == 4) {
    readLessTxtCount = 134;
  }
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [show, setShow] = useState(false);
  const [readMoreTxt, setReadMoreTxt] = useState(readLessTxtCount);
  const [txtHide, setTxtHide] = useState(true);
  const descText = render(card?.description);
  const isEvenIndex = index % 2 === 0;
  const alignDirection = isEvenIndex ? 'flex-start' : 'flex-end';
  const margnleft = isEvenIndex ? '0px' : 'auto';

  const viewText = () => {
    setReadMoreTxt(-1);
    setTxtHide(false);
  };
  const lessText = () => {
    setReadMoreTxt(readLessTxtCount);
    setTxtHide(true);
  };

  return (
    <Box position={"relative"}>
      <Box
        key={nanoid()}
        display={index == 4 ? 'inline-block' : 'flex'}
        justifyContent={alignDirection}
        mb={{ base: '1.5em', md: '10px' }}
        w={{ base: '100%', md: '386px' }}
        alignItems="center"
        marginLeft={margnleft}
      >
        <Box display={'flex'}>
          <Box className='step_icon' mr="10px">
            <Image src={card?.thumbnails[0]?.url} />
          </Box>
          <Box>
            <Box display={'block'} fontFamily={'FedraSansStd-book'} lineHeight={'27px'} color="#90816E" fontSize={'22px'}>
              {card?.title}
            </Box>
            <Box display={'block'} fontWeight={'bold'} fontFamily={'FedraSerifAStdBook'} lineHeight={'27px'} color="#ffffff" fontSize={'22px'} mb="10px">
              {card?.buttonText}
            </Box>

            <StructuredTextParser
              fontSize="16px"
              lineHeight="26px"
              color={"#94B2D3"}
              mt="0"
              str={`${descText.slice(0, readMoreTxt)}${descText.length > readLessTxtCount ? '' : ''
                } `}
            />

            {descText.length > readLessTxtCount && (
              <Show>
                {txtHide ? (
                  <Box
                    width="100%"
                    color="#FFAE27"
                    fontSize="16px"
                    fontFamily="FedraSansStd-book"
                    pt="10px"
                    onClick={viewText}
                    cursor="pointer"
                    textAlign={'left'}
                    className='readmoreless'
                  >
                    READ MORE <Text as="span">+</Text>
                  </Box>
                ) : (
                  <Box
                    width="100%"
                    color="#FFAE27"
                    fontSize="16px"
                    fontFamily="FedraSansStd-book"
                    pt="10px"
                    onClick={lessText}
                    cursor="pointer"
                    textAlign={'left'}
                    className='readmoreless'
                  >
                    {'READ LESS -'}
                  </Box>
                )}
              </Show>
            )}
            <style jsx global>
              {`
                  .readmoreless span {
                      font-size: 24px;
                      padding-left: 10px;
                      line-height: 16px;
                  }
                      
              `}
            </style>
          </Box>
        </Box>
      </Box>
      {index == 4 && (
        <Box background={{base:bgcolor, md:'transparent'}} position={!isMobile && "absolute"} top={!txtHide && "190px"} height={{ base: '80px', md: '200px' }} display={'inline-block'} width={{ base: '100%', md: '325px' }}
        >
          <SimpleButton
            color="black"
            style={btn}
            region={region}
            lang={lang}
            mx="auto"
            width={"188px"}
          />
        </Box>
      )}
    </Box >
  );
};

export default ApplyStep;